import NeuralSearchIcon from 'shared/experiments/components/AlgoliaNeuralSearch/NeuralSearchIcon'

import './NeuralSearchBadge.scss'

const NeuralSearchBadge = () => {
  return (
    <div className="o-NeuralSearchBadge">
      <div className="o-NeuralSearchBadge--tooltip u-position--relative">
        <span className="o-NeuralSearchBadge--tooltipText u-padding-x-small u-position--absolute u-text-align--center u-visibility--hidden u-background-color--background-light">
          Durch künstliche Intelligenz (KI) generierte Empfehlung zu Ihrer
          Suche.
        </span>
        <NeuralSearchIcon />
      </div>
    </div>
  )
}

export default NeuralSearchBadge
